import { Pipe, PipeTransform } from '@angular/core';
import { Models } from '@ibexfusion/models';
import { ContentPipeService } from '@services/content-pipe/content-pipe.service';

@Pipe({
    name: 'socialMediaPipe',
    standalone: false
})
export class SocialMediaPipe implements PipeTransform {
  constructor(private contentPipeService: ContentPipeService) {
  }

  transform(entry: any): Models.SocialMediaEntry | Models.SocialMediaEntry[] {
    if (!entry) {
      return null;
    }

    if (!entry.content) {
      return null;
    }

    const contentEntry: any = entry;
    if (contentEntry && contentEntry.content
      && contentEntry.dataFiles && contentEntry.dataFiles.length) {
      const file: any = this.contentPipeService.getDocuments(contentEntry);
      if (file && file.url) {
        contentEntry.dataFiles.image = file.url;
      }
    }
    const socialMediaEntry: any = new Models.SocialMediaEntry();
    socialMediaEntry.populateFromJSON({
      sourceId: contentEntry._id,
      title: contentEntry.title,
      description: contentEntry.content.textContent,
      link: contentEntry.content.link,
      otherLogo: contentEntry.content.otherLogo,
      platform: contentEntry.content.platform,
      media: this.contentPipeService.getMedia(contentEntry)
    })
    socialMediaEntry.contentType = 'social-media';
    return socialMediaEntry;
  }
}
